/**
 * Monta o corpo do POST `/v2/Contracts/promotion`.
 *
 * O identificador da cotação (API v2) é um **hash** (ex.: `f6loc`), não um número.
 * O código antigo fazia `parseInt(quote_id)`, o que transformava o hash em `NaN`
 * e, ao serializar em JSON, virava `quote_id: null` — causando 400 no backend.
 * Aqui enviamos o `quote_id` como string (igual ao POST `/Contracts` do pagamento).
 */
export function buildPromotionRequest(
  quoteId: string,
  payload?: Record<string, unknown>,
  organizationId?: string
): Record<string, unknown> {
  return {
    quote_id: String(quoteId ?? '').trim(),
    ...(payload ?? {}),
    ...(organizationId ? { organization_id: organizationId } : {})
  };
}
